import React, { useState,useEffect } from "react";
import "./CreateEvent.css";
import { createEvent } from "../services/eventService"; 
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { getEventById, updateEvent } from "../services/eventService";
import LocationPicker from "../components/LocationPicker";


const CreateEvent = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [venue, setVenue] = useState("");
  const [address, setAddress] = useState("");
  const [coordinates, setCoordinates] = useState("");
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [tickets, setTickets] = useState([
    { category: "", price: "", count: "" },
  ]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [kokoSelected, setKokoSelected] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams(); // event id if editing
  const isEditMode = Boolean(id);


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handleTicketChange = (index, field, value) => {
    const newTickets = [...tickets];
    newTickets[index][field] = value;
    setTickets(newTickets);
  };

  const addTicket = () => {
    setTickets([...tickets, { category: "", price: "", count: "" }]);
  };

  const removeTicket = (index) => {
    const newTickets = tickets.filter((_, i) => i !== index);
    setTickets(newTickets);
  };
  useEffect(() => {
  if (!isEditMode) return;

  const fetchEvent = async () => {
    try {
      const event = await getEventById(id);

      setTitle(event.title || "");
      setDescription(event.description || "");
      setVenue(event.venue || "");
      setAddress(event.address || "");
      setCoordinates(event.coordinates || "");
      setTickets(event.tickets || []);
      if (event.payment_method_ids) {
        const pmIds = typeof event.payment_method_ids === "string" ? JSON.parse(event.payment_method_ids || "[]") : event.payment_method_ids;
        setKokoSelected(Array.isArray(pmIds) ? pmIds.includes(4) : false);
      }

      if (event.image) {
        setImagePreview(event.image);
      }
    } catch (err) {
      console.error("Failed to load event", err);
    }
  };

  fetchEvent();
}, [id, isEditMode]);



const handleSubmit = async (e) => {
  e.preventDefault();

  if (!title || !description || tickets.length === 0) {
    setMessage("Please fill all required fields");
    return;
  }

  setLoading(true);

  try {
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user?.id;

    if (!userId) {
      setMessage("User not logged in");
      setLoading(false);
      return;
    }

    const paymentMethodIds = [];
    if (kokoSelected) paymentMethodIds.push(4);

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("venue", venue);
    formData.append("address", address);
    formData.append("coordinates", coordinates);
    formData.append("tickets", JSON.stringify(tickets));
    formData.append("payment_method_ids", JSON.stringify(paymentMethodIds));

    if (image) formData.append("image", image);

    let response;

    if (isEditMode) {
      // ✅ UPDATE EVENT
      response = await updateEvent(id, formData);
      setMessage("Event updated successfully");
    } else {
      // ✅ CREATE EVENT
      formData.append("user_id", userId);
      response = await createEvent(formData);
      console.log("Create response:", response);
      setMessage("Event created successfully");
    }

    navigate("/event");
  } catch (err) {
    console.error(err);
    setMessage(err.response?.data?.message || "Error saving event");
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="ce-container">
    <div className="ce-back-wrapper" onClick={() => navigate("/event")}>
    ← Back to Events
    </div>
      <h2 className="ce-title">
    {isEditMode ? "Edit Event" : "Create New Event Listing"}
    </h2>
      <form className="ce-form" onSubmit={handleSubmit}>
        {/* Event Details */}
        <div className="ce-field">
          <label className="ce-label">Event Title</label>
          <input
            className="ce-input"
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter event title"
          />
        </div>

        <div className="ce-field">
          <label className="ce-label">Description</label>
          <textarea
            className="ce-textarea"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Enter event description"
          />
        </div>

        <div className="ce-field">
          <label className="ce-label">Event Venue / Location Name</label>
          <input
            className="ce-input"
            type="text"
            value={venue}
            onChange={(e) => setVenue(e.target.value)}
            placeholder="e.g. Lotus Tower Arena or Viharamahadevi Open Air Theatre"
          />
        </div>

        <div className="ce-field">
          <label className="ce-label">Venue Physical Address</label>
          <input
            className="ce-input"
            type="text"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            placeholder="e.g. Lotus Tower, D. R. Wijewardena Mawatha, Colombo 10"
          />
        </div>

        <LocationPicker
          value={coordinates}
          onChange={setCoordinates}
          address={address}
          onAddressChange={setAddress}
          required={false}
          label="Google Maps Location Link or Coordinates (Optional)"
          placeholder="e.g. 6.9271, 79.8612 or https://maps.app.goo.gl/..."
          helpText="Pick the event venue location on the interactive map or enter coordinates / Google Maps link manually."
        />

        {/* Image Upload */}
        <div
        className="ce-image-upload-box"
        onClick={() => document.getElementById("event-image-input").click()}
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => {
            e.preventDefault();
            if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            handleImageChange({ target: { files: e.dataTransfer.files } });
            }
        }}
        >
        {imagePreview ? (
            <img className="ce-image-preview" src={imagePreview} alt="Preview" />
        ) : (
            <p>Click or Drag & Drop to upload event image</p>
        )}
        <input
            type="file"
            id="event-image-input"
            accept="image/*"
            style={{ display: "none" }}
            onChange={handleImageChange}
        />
        </div>


        {/* Tickets */}
        <div className="ce-tickets-section">
          <h3 className="ce-subtitle">Tickets</h3>
          {tickets.map((ticket, index) => (
            <div className="ce-ticket-row" key={index}>
              <input
                className="ce-ticket-input"
                type="text"
                placeholder="Category"
                value={ticket.category}
                onChange={(e) =>
                  handleTicketChange(index, "category", e.target.value)
                }
              />
              <input
                className="ce-ticket-input"
                type="number"
                placeholder="Price"
                value={ticket.price}
                onChange={(e) =>
                  handleTicketChange(index, "price", e.target.value)
                }
              />
              <input
                className="ce-ticket-input"
                type="number"
                placeholder="Count"
                value={ticket.count}
                onChange={(e) =>
                  handleTicketChange(index, "count", e.target.value)
                }
              />
              <button
                type="button"
                className="ce-remove-ticket-btn"
                onClick={() => removeTicket(index)}
              >
                ×
              </button>
            </div>
          ))}
          <button type="button" className="ce-add-ticket-btn" onClick={addTicket}>
            + Add Ticket
          </button>
        </div>

        {/* Payment Methods */}
        <div className="ce-field">
          <h3 className="ce-subtitle">Payment Methods (Optional)</h3>
          <div className="ce-payment-methods">
            <label className="ce-checkbox-label">
              <input
                type="checkbox"
                checked={kokoSelected}
                onChange={(e) => setKokoSelected(e.target.checked)}
              />
              <span>KoKo Pay (Buy Now Pay Later - 3 Installments)</span>
            </label>
          </div>
        </div>

        <button type="submit" className="ce-submit-btn" disabled={loading}>
          {loading ? "Creating..." : "Save Event"}
        </button>

        {message && <p className="ce-message">{message}</p>}
      </form>
    </div>
  );
};

export default CreateEvent;
